import React from "react";
import { observer } from 'mobx-react';
import { reaction, observable } from 'mobx';
import PageHeader from '@components/PageHeader';
import PageFooter from '@components/PageFooter';
import CustomInput from '@components/CustomInput';
import VerifyStore from '@stores/VerifyStore';
import utils from '@utils/utils';
import validate from '@utils/validate';

@observer
export default class VerifyPage extends React.Component {
    @observable pageState = {
        pin: {
            value: '',
            valid: false,
            changed: false
        }
    };

    constructor() {
        super();

        this.handleChange = this.handleChange.bind(this);
        this.blurEventHandler = this.blurEventHandler.bind(this);
    }

    handleChange(event, validator) {
        this.pageState[event.target.id].value = event.target.value;
        this.pageState[event.target.id].valid = validator();
        this.pageState[event.target.id].changed = true;
        this.manualBlur(event.target, this.pageState[event.target.id].valid);
    }

    manualBlur = utils.debounce(function(target, valid){
        if(valid === true) {
            target.blur();
            target.focus();
        }
    }, 1500);

    blurEventHandler(event) {
        if(this.pageState[event.target.id].valid === true && this.pageState[event.target.id].changed === true) {
            VerifyStore.sendFormField({
                field: event.target.id,
                value: this.pageState[event.target.id].formatValue ? this.pageState[event.target.id].formatValue(event.target.value) : event.target.value
            });
            this.pageState[event.target.id].changed = false;
        }
    }

    render() {
        return (
            <div className="padding-bot-50">
                <PageHeader title="Verify PIN"/>
                <form onBlur={this.blurEventHandler}>
                    <div className="margin-bot-10">
                        <div className="padding-left-10 margin-top-50">
                            <div className="inline-block margin-bot-15 col">
                                <label htmlFor="pin">Please enter your account PIN<abbr title="required">*</abbr></label>
                                <CustomInput id="pin" 
                                    placeholder="PIN" 
                                    value={this.pageState.pin.value} 
                                    onChange={this.handleChange} 
                                    type="password" 
                                    maxLength="5" 
                                    ruleMessage="Please enter a valid PIN." 
                                    isValid={this.pageState.pin.valid} 
                                    validator={() => { return validate.isValidString(this.pageState.pin.value, 4, 5);}} 
                                    required="required" 
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                    </div>
                </form>
                <PageFooter />
            </div>
        );
    }

    componentDidMount() {
        
    }

    componentWillUnmount() {
 
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/VerifyPage.js